var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-header":"","no-body":""}},[_c('div',{ref:_vm.divRef,class:(_vm.divClass + " overflow-auto")})])}
var staticRenderFns = []

export { render, staticRenderFns }